<div
  class="top-bar"
  fxLayout="row"
  fxLayoutGap="20px"
  fxLayoutAlign="left center"
  [ngClass]="{ 'top-bar__backoffice': isBackoffice }"
>
  <img
    [src]="
      isBackoffice
        ? '../../../assets/pathways_logo_white.png'
        : '../../../assets/pathways_logo.png'
    "
    alt="Pathways Logo!"
    class="logo-img"
  />
  <h1 class="bold top-title">
    {{ headerTitle | translate }}
  </h1>

  <div
    fxLayoutAlign="end center"
    fxLayoutWrap="wrap-reverse"
    class="language-picker"
  >
    <button
      mat-button
      [ngStyle]="{ opacity: lang.currentLang === 'en' ? 1 : 0.5 }"
      [ngClass]="{ selected: lang.currentLang === 'en' }"
      (click)="setLang('en')"
      class="green-color"
    >
      <span class="large-text">{{ "English" | translate }}</span>
      <span class="sm-text">en</span>
    </button>
    <span class="separator"></span>
    <button
      mat-button
      [ngStyle]="{ opacity: lang.currentLang === 'fr' ? 1 : 0.5 }"
      (click)="setLang('fr')"
      [ngClass]="{ selected: lang.currentLang === 'fr' }"
      class="green-color"
    >
      <span class="large-text">{{ "French" | translate }}</span>
      <span class="sm-text">fr</span>
    </button>
    <h5 *ngIf="orgInfo" class="user-details">
      {{ orgInfo.name }}
    </h5>
    <button
      *ngIf="!signedInUser && !isAccountRegistration"
      mat-button
      id="headerEnglishLink"
      name="headerEnglishLink"
      (click)="onLogin()"
    >
      <mat-icon aria-hidden="false" lass="nav-icon">login</mat-icon
      >{{ "Log In" | translate }}
      <!-- <mat-icon class="nav-icon">exit_to_app</mat-icon>Log In -->
    </button>
    <!-- </div>
    </div> -->
    <button mat-button id="headerHome" name="headerHome" *ngIf="signedInUser">
      {{ "Welcome" | translate }}
      {{ signedInUser.firstName + " " + signedInUser.lastName[0] + "." }}
      <mat-icon color="accent">verified_user</mat-icon>
    </button>
    <button
      *ngIf="signedInUser"
      mat-button
      id="headerEnglishLink"
      name="headerEnglishLink"
      (click)="onLogout()"
    >
      <mat-icon class="nav-icon">exit_to_app</mat-icon
      >{{ "Log Out" | translate }}
    </button>
  </div>
</div>
